import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=44f2511a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=44f2511a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f2511a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f2511a')) {
      api.createRecord('44f2511a', component.options)
    } else {
      api.reload('44f2511a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=44f2511a&scoped=true&", function () {
      api.rerender('44f2511a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h29JVzFFrSgZ/JS/comp/GuestBox.vue"
export default component.exports